module.exports = __webpack_public_path__ + "assets/f7aed16b142419b1821d65d5b1484213.png";